// src/components/MainApp/index.tsx

import MainApp from './MainApp';

export * from './MainApp';
export default MainApp;
